import { render, staticRenderFns } from "./IngredientChip.vue?vue&type=template&id=404adfd4&"
import script from "./IngredientChip.vue?vue&type=script&lang=js&"
export * from "./IngredientChip.vue?vue&type=script&lang=js&"
import style0 from "./IngredientChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports